var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v("Mail Client Settings")]),
          _c(
            "gg-card-text",
            [
              _vm.loading
                ? _c("gg-loading", {
                    attrs: {
                      loading: true,
                      type: "setting-rows",
                      types: _vm.skeleton
                    }
                  })
                : !_vm.rows.length
                ? _c(
                    "div",
                    {
                      staticClass: "py-8 text-center"
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "mb-0"
                        },
                        [
                          _vm._v(
                            "Settings for this mailbox aren't available right now."
                          )
                        ]
                      )
                    ]
                  )
                : [
                    _vm._l(_vm.rows, function(row) {
                      return _c(
                        "v-row",
                        {
                          key: row.label,
                          staticClass: "align-center",
                          attrs: {
                            dense: ""
                          }
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "body-2",
                              attrs: {
                                cols: "12",
                                sm: "4"
                              }
                            },
                            [_vm._v(_vm._s(row.label))]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex align-center flex-wrap",
                              attrs: {
                                cols: "12",
                                sm: "8"
                              }
                            },
                            [
                              _c("kvm-copyable", {
                                attrs: {
                                  value: row.value
                                }
                              }),
                              row.ports
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "body-2 text--secondary ml-3"
                                    },
                                    [_vm._v(_vm._s(row.ports))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    _c(
                      "v-row",
                      {
                        staticClass: "align-center",
                        attrs: {
                          dense: ""
                        }
                      },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "body-2",
                            attrs: {
                              cols: "12",
                              sm: "4"
                            }
                          },
                          [_vm._v("Password")]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "body-2",
                            attrs: {
                              cols: "12",
                              sm: "8"
                            }
                          },
                          [_vm._v("Use your mailbox password")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "p",
                      {
                        staticClass: "body-2 mt-4 mb-0"
                      },
                      [
                        _vm._v(
                          " Incoming and outgoing mail both require authentication. "
                        )
                      ]
                    )
                  ]
            ],
            2
          )
        ],
        1
      ),
      _c(
        "gg-card",
        {
          staticClass: "mt-6"
        },
        [
          _c("gg-card-header", [_vm._v("Email These Settings")]),
          _c(
            "gg-card-text",
            [
              _c(
                "p",
                {
                  staticClass: "body-2"
                },
                [
                  _vm._v(
                    " Send the settings for " +
                      _vm._s(_vm.mailbox.email) +
                      " to another address. "
                  )
                ]
              ),
              _c(
                "v-form",
                {
                  on: {
                    submit: function submit($event) {
                      $event.preventDefault()
                      return _vm.send($event)
                    }
                  }
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "align-end"
                    },
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [
                          _c("gg-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|email",
                                expression: "'required|email'"
                              }
                            ],
                            attrs: {
                              label: "Email",
                              name: "Email",
                              placeholder: "you@example.com",
                              "hide-details": "auto",
                              "error-messages": _vm.errors.collect("Email")
                            },
                            model: {
                              value: _vm.recipient,
                              callback: function callback($$v) {
                                _vm.recipient = $$v
                              },
                              expression: "recipient"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                height: "40",
                                loading: _vm.sending,
                                disabled: _vm.loading
                              },
                              on: {
                                click: _vm.send
                              }
                            },
                            [_vm._v(" Send Instructions ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }